export const initialFormState = {
    email: {
        elementConfig: {
            name: 'username',
            type: 'email',
			placeholder: 'Your email'
        },
        value: '',
        validation: {
			minLength: 5,
            maxLength: 63,
            isEmail: true,
        },
        valid: false,
        touched: false,
        errorMessage: '',
    },
};
